const $ = window.jQuery;

export default function scrollTo(position, speed) {
    $('html, body').animate(
        {
            scrollTop: position,
        },
        speed,
    );
}
